import { ENDPOINTS } from "../../Config/endpoints";
import protectedApi from 'Config/protectedApi';

// Main Header
export const postMainHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.post(ENDPOINTS.main_header, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const searchMainHeaderFn = ({ search, page }) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.main_header}?search=${search}&page=${page}`);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const updateMainHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.patch(ENDPOINTS.main_header, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const getMainHeaderFn = () => {
    try {
        const response = protectedApi.get(ENDPOINTS.main_header);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const deleteMainHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.delete(ENDPOINTS.main_header, { data: reqBody });
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const getBusinessTypeFn = (reqBody) => {
    try {
        const response = protectedApi.get(ENDPOINTS.business_type_list, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const getSellerListFn = (reqBody) => {
    try {
        const response = protectedApi.get(ENDPOINTS.seller_list_api, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const searchHeaderFn = ({ search, page }) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.header}?search=${search}&page=${page}`);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const deleteHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.delete(ENDPOINTS.header, { data: reqBody });
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const updateHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.patch(ENDPOINTS.header, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const postHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.post(ENDPOINTS.header, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const getHeaderFn = () => {
    try {
        const response = protectedApi.get(ENDPOINTS.header);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const postSubHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.post(ENDPOINTS.sub_header, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const updateSubHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.patch(ENDPOINTS.sub_header, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const deleteSubHeaderFn = (reqBody) => {
    try {
        const response = protectedApi.delete(ENDPOINTS.sub_header, { data: reqBody });
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const searchSubHeaderFn = ({ search, page }) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.sub_header}?search=${search}&page=${page}`);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}